import { render, staticRenderFns } from "./SystemConfigPage.vue?vue&type=template&id=57707b7b&scoped=true"
import script from "./SystemConfigPage.vue?vue&type=script&lang=js"
export * from "./SystemConfigPage.vue?vue&type=script&lang=js"
import style0 from "./SystemConfigPage.vue?vue&type=style&index=0&id=57707b7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57707b7b",
  null
  
)

export default component.exports